export default __webpack_public_path__ + "static/media/small.7adb0e16.svg";